import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//

import Box from "@mui/material/Box";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";
import ButtonMain from "../../../../../../common/components/button/ButtonMain";
import { StoreContext } from "../../../../../../store/StoreProvider";
import useLocaleRoute from "../../../../../../common/hooks/useLocaleRoute";
import urls from "../../../../../../api/project/ApiUrls";
import useModulePublic from "../../../../../hooks/useModulePublic";
import fireAuth from "../../../../../../api/firebase/auth/utils";
//
import {
  saveAdjustToolSetting,
  clearAdjustToolSetting,
  isChanged,
} from "../../settingControl/useSetting";
import { MODULE_ID } from "../../../../../../config/CONSTANTS";

const BottomPanel = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user, sna } = state;
  const { locale } = user;
  const { adjust } = sna;
  // local state
  const [test, setTest] = useState(0);
  const [datasetSelect, setDatasetSelect] = useState([]);
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();
  const handleDisabled = (moduleId) => !handlePublic(moduleId);
  //
  const isLoggedIn = fireAuth.isLoggedIn(user);

  const dataChanged = isChanged(adjust);
  const disabledApplyBtn = !dataChanged;
  const disabledSaveBtn = !dataChanged;
  const showClearSetting = handlePublic(MODULE_ID.snaSidebarAdjustClearSetting);

  const getApplyBtnSx = () => {
    if (disabledApplyBtn) {
      return {
        "&.MuiButton-root": {
          color: "#909090",
          backgroundColor: "#505050",
        },
      };
    }
    return {};
  };

  const getSaveBtnSx = () => {
    if (disabledSaveBtn) {
      return {
        "&.MuiButton-root": {
          color: "#909090",
          backgroundColor: "#505050",
        },
      };
    }
    return {};
  };

  const applySetting = () => {
    console.log("applySetting adjust");
    saveAdjustToolSetting(state, dispatch);
  };

  const clearSetting = () => {
    console.log("clearSetting adjust");
    // todo: 儲存到 firebase
    clearAdjustToolSetting(state, dispatch);
  };

  return (
    <Box my={4}>
      <Box mb={2}>
        <ButtonMain
          buttonProps={{
            text: intl.formatMessage({
              id: "sna.sidebar.adjusttool.bottompanel.apply.setting",
              defaultMessage: "套用條件",
            }),
            fullWidth: true,
            onClick: applySetting,
            disabled: disabledApplyBtn,
            variant: disabledApplyBtn ? "disabled" : null,
            sx: { ...getApplyBtnSx() },
          }}
        />
      </Box>
      {showClearSetting && (
        <Box mb={2}>
          <ButtonMain
            buttonProps={{
              text: intl.formatMessage({
                id: "sna.sidebar.adjusttool.bottompanel.clear.setting",
                defaultMessage: "清除條件",
              }),
              fullWidth: true,
              onClick: clearSetting,
              disabled: disabledSaveBtn,
              variant: disabledSaveBtn ? "disabled" : null,
              sx: { ...getSaveBtnSx() },
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default BottomPanel;
